export const ADDRESS = [
  { address: 'São Paulo', phone: '928 689 936' },
  { address: 'Viana', phone: '935 174 070' },
  { address: 'Via expresso (Benfica)', phone: '932 223 159' },
];
